module.exports = __webpack_public_path__ + "img/logo-4.8d385de4.png";